import { useState } from "react";
import { object, string, arrayOf } from "prop-types";
import { observer } from "mobx-react";
import { lastResourceNameUsage } from "@utils";
import {
  useEstimateStructure,
  useEstimateEditorStore,
  TeamMemberSelectDialog,
} from "@tools";

export const TeamMemberSelect = observer(({
  teamMember,
  workTypeId,
  sectionId,
  currentlyAddedTeamMembers,
}) => {
  const structure = useEstimateStructure();
  const editorStore = useEstimateEditorStore();

  const { id, name, autoFocus } = teamMember;
  const { importRoleCostRates, importRoleSalesRates } = editorStore;

  const [ newlyCreatedRole, setNewlyCreatedRole ] = useState(autoFocus);

  const updateRole = (newRole) => {
    structure.historyManager.startGroup();

    const { id: systemId, roleName, salesRate, costRate, existingWorkTypeRole } = newRole;
    const summaryWorkType = structure.getWorkTypeById(workTypeId);
    let newSalesRate, newCostRate, newId = id, oldId = id;

    const lastNameUsage = lastResourceNameUsage(
      summaryWorkType?.resources,
      roleName
    );

    const newName = lastNameUsage >= 0
      ? `${roleName} ${lastNameUsage + 1}`
      : roleName;

    if(salesRate && importRoleSalesRates)
      newSalesRate = salesRate;
    if(costRate && importRoleCostRates)
      newCostRate = costRate;

    if(existingWorkTypeRole) {
      newId = structure.changeTimelineTeamMember(
        sectionId,
        workTypeId,
        oldId,
        systemId,
      );
      teamMember.updateId(newId);
    } else if(!newlyCreatedRole) {
      newId = structure.changeTimelineTeamMember(
        sectionId,
        workTypeId,
        oldId,
        undefined,
        newName,
        systemId,
        newSalesRate,
        newCostRate,
      );
      teamMember.updateId(newId);
    } else {
      summaryWorkType.addResource(false, newId, newName, systemId, newSalesRate, newCostRate)
      structure.addSectionsResource(workTypeId, newId, sectionId);
    }

    setNewlyCreatedRole(false);
    structure.historyManager.stopGroup();
  };

  return (
    <TeamMemberSelectDialog
      workTypeId={workTypeId}
      defaultValue={name}
      updateRole={updateRole}
      autoFocus={autoFocus}
      removeAutofocus={teamMember.removeAutofocus}
      selfRemoveTeamMember={teamMember.removeSelf}
      listExistingTeamMembers
      currentlyAddedTeamMembers={currentlyAddedTeamMembers}
    />
  );
});

TeamMemberSelect.propTypes = {
  teamMember: object.isRequired,
  workTypeId: string.isRequired,
  sectionId: string.isRequired,
  currentlyAddedTeamMembers: arrayOf(string).isRequired,
};
